import React from 'react';
import styled from '@emotion/styled';
import { useLocation, useNavigate } from 'react-router-dom';
import { JoinRoom, Button } from '@app/components';
import { useNavigateToRoom, joinRoom, themeService } from '@app/services';

const Container = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
});

const Box = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: '300px',
});

export const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const navigateToRoom = useNavigateToRoom();

  const goToRoom = async (roomName, isAdmin) => {
    if (!isAdmin) await joinRoom(roomName);

    navigateToRoom(roomName, isAdmin);
  };

  return (
    <Container>
      <Box>
        <h2>Join existing room</h2>
        <JoinRoom room={location.state?.id} onJoin={(roomName) => goToRoom(roomName, false)} />
      </Box>

      <Box>
        <h2>Settings</h2>
        <Button onClick={() => themeService.toggleTheme()}>Toggle theme</Button>
        <br />
        <Button onClick={() => navigate('/player-info')}>Change name</Button>
        <br />
        <Button onClick={() => navigate('/admin')}>Manage rooms</Button>
      </Box>
    </Container>
  );
};
